module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text mx-0",
    attrs: {
      "slot": "activator",
      "outline": "",
      "large": ""
    },
    slot: "activator"
  }, [_vm._t("default", [_vm._v("Marcar como realizada")])], 2), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Marcar vistoria como realizada?")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("Para marcar uma vistoria como realizada você precisa anexar uma foto referente a vistoria.")])]), _vm._v(" "), _c('v-card-text', [_c('file-input', {
    key: _vm.inputKey,
    attrs: {
      "accept": "image/*",
      "icon": "add_a_photo",
      "label": "Selecionar foto"
    },
    on: {
      "formData": _vm.onFilePicked
    },
    model: {
      value: (_vm.form.fields.fotoFilename),
      callback: function($$v) {
        _vm.form.fields.fotoFilename = $$v
      },
      expression: "form.fields.fotoFilename"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Legenda"
    },
    model: {
      value: (_vm.form.fields.legenda),
      callback: function($$v) {
        _vm.form.fields.legenda = $$v
      },
      expression: "form.fields.legenda"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "error--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.descartar($event)
      }
    }
  }, [_vm._v("Ainda não")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441806bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vistoria/VistoriaRealizar.vue
// module id = 1014
// module chunks = 1